/** Init splash from index.html (#splash): lives outside #root and fades out once the first screen is ready. */
const MIN_VISIBLE_MS = 900;
const FALLBACK_MS = 8000;

let hidden = false;

export const hideSplash = (): void => {
  if (hidden) return;
  const el = document.getElementById('splash');
  if (!el) return;
  hidden = true;
  // Let the intro finish on fast opens.
  const wait = Math.max(0, MIN_VISIBLE_MS - performance.now());
  window.setTimeout(() => {
    el.classList.add('is-hidden');
    window.setTimeout(() => el.remove(), 400);
  }, wait);
};

/** Safety net: routes without a ready signal (redirects, load errors) must not stay under the splash. */
export const scheduleSplashFallback = (): void => {
  window.setTimeout(hideSplash, FALLBACK_MS);
};
